import {fade} from '@material-ui/core/styles/colorManipulator'

const styles = theme => ({
  newTestSection: {
    padding: theme.spacing.unit * 3,
    display: 'flex',
    flexDirection: 'column',
  },
  nameSection: {
    display: 'grid',
    gridGap: `${theme.spacing.unit}px`,
    paddingBottom: theme.spacing.unit * 2,
    position: 'relative',
    '&::after': {
      content: '""',
      height: 1,
      width: '100%',
      background: theme.palette.border.main,
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  titleSection: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  titleWithToggle: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gridGap: `${theme.spacing.unit}px`,
  },
  viewToggleButton: {
    background: '#fff',
    border: `1px solid ${theme.palette.border ? theme.palette.border.main : '#DCE1E7'}`,
    borderRadius: 6,
    padding: '4px 12px',
    color: theme.palette.grey[700],
    fontWeight: 600,
    fontSize: '13.5px',
    textTransform: 'none',
    minHeight: 0,
    '&:hover': {
      borderColor: theme.palette.grey[400],
      background: theme.palette.surface ? theme.palette.surface[100] : '#F6F9FC',
    },
  },
  viewToggleButtonOn: {
    background: fade(theme.palette.primary.main, 0.08),
    borderColor: fade(theme.palette.primary.main, 0.3),
    color: theme.palette.primary.main,
    '&:hover': {
      background: fade(theme.palette.primary.main, 0.14),
      borderColor: fade(theme.palette.primary.main, 0.3),
    },
  },
  placeAfterSection: {
    display: 'grid',
    gridGap: `${theme.spacing.unit / 2}px`,
  },
  placeAfterStatus: {
    fontSize: '12.5px',
    fontWeight: 700,
    color: theme.palette.primary.main,
    minHeight: 18,
  },
  typeSection: {
    display: 'grid',
    gridGap: `${theme.spacing.unit}px`,
    marginTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 2,
    position: 'relative',
    '&::after': {
      content: '""',
      height: 1,
      width: '100%',
      background: theme.palette.border.main,
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
    },
    '& $sectionSubtitle': {
      opacity: 0.6,
      color: '#292D32',
    },
  },
  sectionTitle: {
    width: 'max-content',
    fontSize: '1.1em',
    color: '#292D32',
    position: 'relative',
    marginRight: 24,
  },
  sectionSubtitle: {
    fontSize: '1em',
  },
  sectionSubtitle2: {
    fontSize: '14px',
    lineHeight: '15px',
  },
  nameInput: {
    width: '100%',
  },
  nameLengthIndicator: {
    fontSize: '0.75rem',
    color: theme.palette.surface[600],
    marginLeft: 'auto',
    marginTop: theme.spacing.unit * 0.5,
  },
  notchedOutline: {
    borderColor: `${theme.palette.border ? theme.palette.border.main : 'initial'} !important`,
  },
  errorOutline: {
    borderColor: `${theme.palette.secondary.main} !important`,
  },
  inputErrorText: {
    marginLeft: 0,
    color: theme.palette.secondary.main,
  },
  nextButton: {
    alignSelf: 'flex-end',
    marginTop: 'auto',
  },
  uploadSection: {
    display: 'grid',
    gridGap: `${theme.spacing.unit}px`,
    paddingTop: theme.spacing.unit * 1.5,
    paddingBottom: theme.spacing.unit * 2,
    position: 'relative',
    '& $sectionSubtitle': {
      opacity: 0.6,
      color: '#292D32',
      fontSize: '0.75em',
      paddingTop: 10,
    },
  },
  scheduleSection: {
    display: 'grid',
    gridGap: `${theme.spacing.unit}px`,
    paddingTop: theme.spacing.unit * 1.5,
    paddingBottom: theme.spacing.unit * 3,
  },
  selectRoot: {
    overflow: 'hidden',
    width: '100%',
  },
  selectIcon: {
    marginRight: theme.spacing.unit * 3,
  },
  disabledIcon: {
    display: 'none',
  },
  selectMenu: {
    fontSize: '0.9em',
    paddingRight: theme.spacing.unit * 6,
  },
  dateTimeInput: {
    fontSize: '0.9em',
  },
  calendarIcon: {
    width: 20,
    filter:
      'invert(11%) sepia(4%) saturate(1906%) hue-rotate(173deg) brightness(102%) contrast(85%)',
  },
  questionFormContainer: {
    display: 'grid',
    gridGap: `${theme.spacing.unit}px`,
    maxHeight: '60vh',
    overflowY: 'auto',
    marginBottom: theme.spacing.unit,
  },
  surveysButtonsContainers: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
  },
  surveysButtonsRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '16px',
  },
  surveysButtonsBtn: {
    width: 'max-content',
    alignSelf: 'initial',
    marginRight: '12px',
    fontWeight: 400,
    fontSize: '14px',
  },
  surveysButtonsBtnDownloadTemplate: {
    textDecoration: 'underline',
    textTransform: 'none',
    color: '#017EFF',
    padding: 0,
    minWidth: 'auto',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: '14px',
    fontFamily: 'Roboto',
    lineHeight: '24.5px',
  },
  disabledAddButton: {
    cursor: 'initial',
    color: '#BDBFC2',
    '&:hover': {
      background: 'initial',
    },
  },
  formSection: {
    display: 'grid',
    gridGap: `${theme.spacing.unit}px`,
  },
  questionHeader: {
    alignItems: 'center',
    '& button': {
      padding: '0 !important',
      marginLeft: theme.spacing.unit,
    },
  },
  demographicGroupHeader: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  duplicateGroupsModalBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 4}px ${theme.spacing.unit * 5}px`,
    borderRadius: theme.spacing.unit,
  },
  duplicateGroupsModalText: {
    width: '30ch',
    textAlign: 'center',
    padding: `${theme.spacing.unit * 2}px 0`,
    fontWeight: 500,
    fontSize: '1.2em',
    color: theme.palette.grey[700],
  },
  duplicateGroupsModalButton: {
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
  },
  totalCompleteSection: {
    alignItems: 'center',
    gridGap: `${theme.spacing.unit}px`,
    '& > p': {
      color: theme.palette.grey[600],
    },
  },
  audienceFormControl: {
    width: '100%',
  },
  audienceSelect: {
    overflow: 'initial',
    whiteSpace: 'initial',
    textOverflow: 'initial',
    paddingRight: '48px',
    display: 'flex',
    flexFlow: 'wrap',
    gridGap: '8px',
  },
  selectedSubDemographic: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: 'white',
  },
  subDemographicChip: {
    borderRadius: theme.spacing.unit,
    color: 'white',
    textTransform: 'capitalize',
    background: theme.palette.grey[500],
    maxWidth: '15ch',
  },
  chipLabel: {
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  audienceSectionSubtitle: {
    fontSize: '1em',
    textTransform: 'capitalize',
  },
  demographicRemoveButton: {
    fontWeight: 400,
    '&:hover': {
      textDecoration: 'underline',
      background: 'initial',
    },
  },
  nextLoadingWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing.unit * 4,
  },
  totalPanelists: {
    margin: 0,
    position: 'relative',
    '& > span': {
      fontWeight: 500,
    },
  },
  invalidPanelists: {
    color: theme.palette.error.main,
  },
  // Advisory per-objective minimum warning — boxed light-red panel mirroring
  // OrderSummary's publishBlockedMessage, deliberately distinct from the red
  // Total Panelists figure that signals the *global* minimum. Sits between
  // "Add New Group" and the pinned bottom section, so keep it compact: the
  // slack it occupies is reserved by audienceBottomSection's marginTop:'auto'.
  objectiveMinimumWarning: {
    background: '#FFEBEE',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.spacing.unit / 2,
    color: theme.palette.secondary.main,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 1.4,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    padding: theme.spacing.unit * 1.5,
  },
  audienceBottomSection: {
    gridGap: '32px',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 'auto',
    [theme.breakpoints.down(1730)]: {
      flexDirection: 'column',
      alignItems: 'center',
      gridGap: '16px',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      gridGap: '32px',
    },
  },
  newAudienceGroupTooltip: {
    maxWidth: 400,
    padding: theme.spacing.unit * 2,
  },
  emptyGroupsMessage: {
    color: theme.palette.surface[700],
    fontSize: '0.9rem',
  },
  audienceGroupsContainer: {
    width: '100%',
    // The cap is viewport-based on purpose, and it looks wrong next to the slack
    // below "Add New Group" — that slack is reserved, not free. This column's own
    // height comes from flex-line stretch inside `newTestBody` (a wrapping Grid
    // container, align-items: stretch), so it equals the TALLEST sibling column;
    // there is no ancestor height to size against here. `maxHeight: '100%'`
    // resolves to `none`, and `flex: 1` would eat the space
    // `audienceBottomSection` reserves with `marginTop: 'auto'` to bottom-align
    // Total Panelists / Next with the other columns' Next buttons.
    // Removing the cap also makes this column the tallest on the line, dragging
    // every sibling's bottom row down with it — and it would silently break the
    // duplicate-group scroll, which needs `scrollHeight > clientHeight`
    // (AudienceGroupCard). Using the available height needs a definite height on
    // `newTestBody` first; that is a separate change.
    maxHeight: '60vh',
    // load-bearing twice: it zeroes the automatic minimum size (without it the
    // minimum outranks maxHeight and the cap stops working) and it makes this
    // element the scroller AudienceGroupCard walks. Never set it to 'visible'.
    overflow: 'auto',
  },
  confirmEditingModal: {
    padding: theme.spacing.unit * 4,
    maxWidth: 500,
  },
  confirmEditingTitle: {
    fontWeight: 600,
    fontSize: '1.8rem',
    textAlign: 'center',
  },
  confirmEditingTextContainer: {
    margin: `${theme.spacing.unit * 4} 0`,
  },
  confirmEditingText: {
    fontSize: '1.1rem',
    margin: `${theme.spacing.unit} 0`,
    textAlign: 'center',
  },
  confirmEditingButton: {
    flexGrow: 1,
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
})

export default styles
